import { Pipe, PipeTransform } from '@angular/core';
import { LgvTSHelper } from '../../core/core.module';


@Pipe({
    name: 'LgvDefaultAgentImage'
})
export class LgvDefaultAgentImagePipe implements PipeTransform {

    transform(imgUrl: string) {
        return (imgUrl === null || imgUrl === undefined) ? "https://rftylusstrblb01.blob.core.windows.net/agent-profile-images/default-profile-image-neutral.png"
            : imgUrl;
    }
}
